// extracted by mini-css-extract-plugin
export default {"horizontal":"LdA7I","vertical":"LgR7S","bullet":"HJyah"};